import { api } from '@utils/api/api'
import { BankCashoutData } from './addMoneyApi'

export async function withdrawWithBank(data: BankCashoutData): Promise<void> {
  return api.post('/api/v1/cashout/bank/linked-payout', data)
}
